import { NgModule } from '@angular/core';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { UiGeneralModule } from '../ui-general/ui-general.module';
import { BrowserModule } from '@angular/platform-browser';
import { HuntPageComponent } from './pages';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PipesModule } from '../core/pipes/pipes.module';
import { HuntFormComponent } from './components/hunt-form/hunt-form.component';
import { MatNativeDateModule, MatInputModule, MatDatepickerModule, MatSelectModule, MatButtonModule, MatIconModule, MatProgressBarModule, MatStepperModule, MatTabsModule, NativeDateModule } from '@angular/material';
import { HunterHealthComponent } from './components/hunter-health/hunter-health.component';
import { AvailableRoomsComponent } from './components/available-rooms/available-rooms.component';
import { BookingConfirmationComponent } from './components/booking-confirmation/booking-confirmation.component';
import { BookingStatusomponent } from './components/booking-status/booking-status.component';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        HuntPageComponent,
        HuntFormComponent,
        HunterHealthComponent,
        AvailableRoomsComponent,
        BookingConfirmationComponent,
        BookingStatusomponent
    ],
    imports: [
        AngularFontAwesomeModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        PipesModule,
        BrowserModule,
        MatNativeDateModule,
        MatInputModule,
        MatDatepickerModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatStepperModule,
        MatTabsModule,
        UiGeneralModule
    ],
    exports: [
        HuntPageComponent,
    ],
    entryComponents: [HuntFormComponent],
    bootstrap: [HuntFormComponent],
  })
  export class HuntModule { }



// WEBPACK FOOTER //
// ./src/app/hunt/hunt.module.ts